import { PreRenderService } from '../../../services/pre-render.service';
import { OnChanges, SimpleChanges } from '@angular/core';
import { RemaxMarker } from '../../../classes/remax-marker';
import { Listing } from '../../../classes/listing';
import { CurrencyPipe } from '@angular/common';
import { Helper } from '../../../classes/helper';
import { ListingsService } from '../../../services/listings.service';
var MapComponent = /** @class */ (function () {
    function MapComponent(currencyPipe, listingService, preRenderService) {
        this.currencyPipe = currencyPipe;
        this.listingService = listingService;
        this.preRenderService = preRenderService;
        this.isOffice = false;
        this.customMapOptions = {};
        this.mapOptions = {
            fullscreenControl: false,
            mapTypeControl: false,
            zoomControl: true,
            streetViewControl: true,
            zoom: 17,
            disableDefaultUI: false,
            draggable: true,
            scrollwheel: true,
            minZoom: 3,
            center: {
                lat: 0,
                lng: 0
            }
        };
        this.mapEnabled = true;
        this.mapEnabled = this.preRenderService.isBrowserMode;
    }
    MapComponent.prototype.ngOnChanges = function (changes) {
        for (var key in this.customMapOptions) {
            this.mapOptions[key] = this.customMapOptions[key];
        }
    };
    Object.defineProperty(MapComponent.prototype, "isLDP", {
        set: function (isLDP) {
            var _this = this;
            if (this.listing) {
                this.listingService.getPriceOrPricePerSqFtString(this.listing).toPromise().then(function (str) { return _this.priceOrPricePerSqFt = str; });
                var price = isLDP ? this.priceOrPricePerSqFt : Helper.formatPrice(this.listing.listPrice);
                this.marker = RemaxMarker.generateListingMarkerFromListing(price, this.listing);
                this.mapOptions.center = {
                    lat: this.listing.lat,
                    lng: this.listing.lng
                };
            }
            else if (this.latLng) {
                this.mapOptions.center = this.latLng;
                this.marker = RemaxMarker.generatePlainMarker(false, this.isOffice, this.latLng);
            }
        },
        enumerable: true,
        configurable: true
    });
    return MapComponent;
}());
export { MapComponent };
